import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EquipmentManager } from './admin/AdminEquipment';
import { DriverInfoContent } from './admin/AdminDriverInfo';
import { ShopOrdersBoard } from './admin/AdminShopOrders';
import { SafetySection } from './admin/AdminSafetyHub';
import { MaterialHub } from './admin/AdminMaterial';
import ActivityPills from '../components/ActivityPills';

// Field-supervisor Shop hub — mirrors the office Shop page (Safety, Shop Orders,
// Equipment, Material, Driver Tools) but chromeless for the phone. Reuses the
// existing office components ("reuse now, polish later").
const TABS = [
  { key: 'safety',     label: 'Safety',       sub: 'Training, docs & JHA',  color: '#e87722' },
  { key: 'shop_order', label: 'Shop Orders',  sub: 'Deliveries & prefab',   color: '#1e3a5f' },
  { key: 'equipment',  label: 'Equipment',    sub: 'Fleet & rentals',       color: '#475569' },
  { key: 'material',   label: 'Material',     sub: 'Received materials',     color: '#065f46' },
  { key: 'driver',     label: 'Driver Tools', sub: 'Fuel, inspections, incidents', color: '#b45309' },
  { key: 'time',       label: 'Time Keeping', sub: 'Clock in / out',        color: '#16a34a', nav: '/time' },
];

export default function SupShop() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const initial = TABS.find(t => t.key === params.get('tab') && !t.nav) ? params.get('tab') : null;
  const [tab, setTab] = useState(initial);
  const active = TABS.find(t => t.key === tab);
  const openOrderId = params.get('order');   // a shop-order notification points right here
  const homeOnly = params.get('home') === '1';   // opened from the field worker's home tile: back goes home, not to the Shop list

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb' }}>
      <div style={{ background: '#111', color: '#fff', paddingTop: 'max(env(safe-area-inset-top), 14px)', paddingBottom: 14, paddingLeft: 16, paddingRight: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => (active && !homeOnly ? setTab(null) : navigate('/dashboard'))}
          style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', padding: 0, color: '#e87722', lineHeight: 1 }}>‹</button>
        <div style={{ fontWeight: 800, fontSize: 17 }}>{active ? active.label : 'Shop'}</div>
      </div>

      {!active ? (
        <div style={{ padding: 16, display: 'grid', gridTemplateColumns: '1fr', gap: 12, maxWidth: 540, margin: '0 auto' }}>
          <ActivityPills pageName="Shop" scope="shop" summaryLabel="Shop Update" linkJobs={false} />
          {TABS.map(t => (
            <button key={t.key} onClick={() => t.nav ? navigate(t.nav) : setTab(t.key)}
              style={{ textAlign: 'left', background: '#fff', border: '1.5px solid #ececec', borderLeft: `5px solid ${t.color}`, borderRadius: 12, padding: '16px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 800, color: '#111' }}>{t.label}</div>
                <div style={{ fontSize: 13, color: '#8a8a8a', marginTop: 2 }}>{t.sub}</div>
              </div>
              <span style={{ color: '#e87722', fontSize: 22 }}>›</span>
            </button>
          ))}
        </div>
      ) : (
        <div style={{ padding: 12 }}>
          {tab === 'safety'     && <SafetySection />}
          {tab === 'shop_order' && <ShopOrdersBoard openOrderId={openOrderId} />}
          {tab === 'equipment'  && <EquipmentManager restricted embedded />}
          {tab === 'driver'     && <DriverInfoContent restricted />}
          {tab === 'material'   && <MaterialHub />}
        </div>
      )}
    </div>
  );
}
